import useTranslation from './hooks/useTranslation';

import type { GetPartTypeLabel, ServicePartType, UsePartTypeLabels } from './types';

const usePartTypeLabels = (): UsePartTypeLabels => {
    const partTypeLabels = useTranslation();

    const getPartTypeLabel: GetPartTypeLabel = partType =>
        partTypeLabels[partType as ServicePartType] ?? partType;

    return { getPartTypeLabel };
};

export default usePartTypeLabels;
